
app.controller("ChangeCompareController", [
    "$scope", "$http", "$uibModalInstance", "oldText", "newText", "htmldiff",
    function ($scope, $http, $uibModalInstance, oldText, newText, htmldiff) {
        $scope.result = "";
        $scope.old = oldText;
        $scope.newText = newText;
        $scope.tinymceOptions = {
            disabled: true,
            menubar: false,
            plugins: 'autoresize',
            toolbar: false
        };
        setTimeout(() => {
            // document.getElementById("oldText").innerHTML = $scope.old;
            document.getElementById("newText").innerHTML = $scope.newText;
            document.getElementById("result").innerHTML = htmldiff(oldText, newText);
        }, 100);

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }]);